import createManager from '../createManager';
export var createCheckboxManager = function createCheckboxManager() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createManager(Object.assign({}, config, {
    state: Object.assign({
      checked: false
    }, config.state),
    actions: Object.assign({
      toggle: function toggle(checked) {
        return function () {
          return {
            checked: checked
          };
        };
      }
    }, config.actions)
  }));
};